module.exports = __webpack_public_path__ + "img/half-7.0574659.png";